export { localStorage } from './localStorage';
export { memoryStorage } from './memoryStorage';
export { MemoryStorage } from './memoryStorageClass';
export { sessionStorage } from './sessionStorage';
export { engine$, Storage, testEngine } from './Storage';
export type { StorageOptions } from './Storage';
